import React, { Component } from "react";
import Router from "./Router";
import { NotificationContainer } from "react-notifications";

class App extends Component {
  render() {
    return (
      <div className="app">
        <Router />
        <NotificationContainer />
      </div>
    );
  }
}

// const mapStateToProps = state => ({
//   alert: state.alert,
//   modal: state.modal,
// });

// const mapDispatchToProps = dispatch => ({
//   clearAlerts: () => dispatch(alertActions.clear()),
//   doCloseModal: () => dispatch(modalActions.doCloseModal()),
//   cleanModalForm: () => dispatch(modalActions.cleanModalForm()),
//   doShowModal: (modalProps) => dispatch(modalActions.doShowModal(modalProps))
// });

// export default connect(mapStateToProps, mapDispatchToProps)(App);
export default App;
